import React from 'react'

const RemoteLocationIcon = () => {
    return (
        <>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xmlnsXlink="http://www.w3.org/1999/xlink"
                width={60}
                height={60}
                x={0}
                y={0}
                viewBox="0 0 512 512"
                style={{ enableBackground: "new 0 0 512 512" }}
                xmlSpace="preserve"
                className=""
            >
                <g>
                    <linearGradient
                        id="a"
                        x1="10.451"
                        x2="404.202"
                        y1="480.016"
                        y2="86.265"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop offset={0} stopColor="#5d99ca" />
                        <stop offset={1} stopColor="#7ed7de" />
                    </linearGradient>
                    <linearGradient
                        xlinkHref="#a"
                        id="b"
                        x1="-90.783"
                        x2="302.968"
                        y1="378.783"
                        y2="-14.968"
                    />
                    <linearGradient
                        xlinkHref="#a"
                        id="c"
                        x1="21.217"
                        x2="414.968"
                        y1="490.783"
                        y2="97.032"
                    />
                    <g data-name="24-Anywhere">
                        <path
                            fill="url(#a)"
                            d="M282.166 109.648A82.854 82.854 0 0 0 288 80a80 80 0 0 0-160 0 82.854 82.854 0 0 0 5.834 29.648 209.821 209.821 0 0 0-90.763 67.6A206.067 206.067 0 0 0 0 304c0 114.691 93.309 208 208 208s208-93.309 208-208a206.067 206.067 0 0 0-43.071-126.757 209.821 209.821 0 0 0-90.763-67.595zM208 480c-18.986 0-38.513-17.273-53.571-47.391A231.068 231.068 0 0 1 137.1 384h141.8a231.068 231.068 0 0 1-17.324 48.609C246.513 462.727 226.986 480 208 480zm-76.861-128A362.141 362.141 0 0 1 128 304a357.813 357.813 0 0 1 3.215-48h153.57A357.813 357.813 0 0 1 288 304a362.141 362.141 0 0 1-3.139 48zM32 304a174.846 174.846 0 0 1 6.721-48h60.2a397.264 397.264 0 0 0-.027 96h-60.24A175.536 175.536 0 0 1 32 304zm132.871-146.446A259.593 259.593 0 0 0 198.4 188.8a16 16 0 0 0 19.2 0 259.593 259.593 0 0 0 33.529-31.246c11.8 17.072 21.277 40.068 27.668 66.446H137.2c6.394-26.378 15.873-49.374 27.671-66.446zM317.076 256h60.2a175.606 175.606 0 0 1 .067 96H317.1a394.676 394.676 0 0 0 2.9-48 392.191 392.191 0 0 0-2.924-48zm47.582-32h-53.01c-6.821-31.287-17.6-59.019-31.525-80.587A176.718 176.718 0 0 1 364.658 224zM208 32a48.054 48.054 0 0 1 48 48c0 27.333-29.111 58.728-48 75.317-18.9-16.6-48-47.988-48-75.317a48.054 48.054 0 0 1 48-48zm-72.123 111.413c-13.923 21.568-24.7 49.3-31.525 80.587h-53.01a176.722 176.722 0 0 1 84.535-80.587zM51.255 384H104.3c5.032 23.124 12.268 44.447 21.5 62.92a186.348 186.348 0 0 0 9.969 17.57A177.149 177.149 0 0 1 51.255 384zm228.969 80.49a186.348 186.348 0 0 0 9.969-17.57c9.237-18.473 16.473-39.8 21.5-62.92h53.047a177.149 177.149 0 0 1-84.516 80.49z"
                            opacity={1}
                            data-original="url(#a)"
                            className=""
                        />
                        <circle
                            cx={208}
                            cy={80}
                            r={16}
                            fill="url(#b)"
                            opacity={1}
                            data-original="url(#b)"
                        />
                        <g fill="url(#c)">
                            <path
                                d="M368 64h-16v32h16a48 48 0 0 1 48 48v16h32v-16a80 80 0 0 0-80-80z"
                                fill=""
                                opacity={1}
                            />
                            <path
                                d="M469.823 42.176A143.06 143.06 0 0 0 368 0h-16v32h16a112 112 0 0 1 112 112v16h32v-16a143.062 143.062 0 0 0-42.177-101.824z"
                                fill=""
                                opacity={1}
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </>
    )
}

export default RemoteLocationIcon